import React from 'react';
import { siteConfig } from '../mock';
import { Phone, Mail, MapPin } from 'lucide-react';
import useSEO from '../hooks/useSEO';

const Contact = () => {
  useSEO({
    title: 'Kontakt — broneeri aeg | Prestige Beauty & Wellness',
    description:
      'Võta meiega ühendust Pärnus: telefon +372 588 80329, e-post kaunisminaou@gmail.com, Hommiku tänav 1. Küsi lisainfot või broneeri aeg.',
    path: '/kontakt',
  });

  return (
    <div>
      <section className="hero-bg pt-32 pb-16 px-6 text-center">
        <h1 className="section-title text-4xl md:text-5xl fade-up">Kontakt</h1>
        <p className="text-brand-muted mt-6 max-w-2xl mx-auto leading-relaxed fade-up fade-up-delay-1">
          Võtke meiega ühendust ja aitame teid meeleldi kõiges vajalikus.
        </p>
      </section>

      <section className="bg-cream-light py-16 px-6">
        <div className="max-w-xl mx-auto space-y-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow">
              <Phone className="w-5 h-5 text-gold" strokeWidth={1.5} />
            </div>
            <div>
              <h4 className="text-brand font-medium">Telefon</h4>
              <a href={`tel:${siteConfig.contact.phone}`} className="text-brand-muted hover:text-brand transition-colors">
                {siteConfig.contact.phone}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow">
              <Mail className="w-5 h-5 text-gold" strokeWidth={1.5} />
            </div>
            <div>
              <h4 className="text-brand font-medium">E-post</h4>
              <a href={`mailto:${siteConfig.contact.email}`} className="text-brand-muted hover:text-brand transition-colors">
                {siteConfig.contact.email}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow">
              <MapPin className="w-5 h-5 text-gold" strokeWidth={1.5} />
            </div>
            <div>
              <h4 className="text-brand font-medium">Aadress</h4>
              <p className="text-brand-muted">{siteConfig.contact.address}</p>
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-lg mt-8">
            <iframe
              title="Kaart"
              src="https://maps.google.com/maps?q=Hommiku%20t%C3%A4nav%201,%20P%C3%A4rnu&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="260"
              style={{ border: 0 }}
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
